import { render } from "./posSvg.vue?vue&type=template&id=28b6ed7b&scoped=true"
import script from "./posSvg.vue?vue&type=script&lang=js"
export * from "./posSvg.vue?vue&type=script&lang=js"

import "./posSvg.vue?vue&type=style&index=0&id=28b6ed7b&scoped=true&lang=css"

import exportComponent from "/home/sergiugata/taptasty/-taptasty-order/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-28b6ed7b"]])

export default __exports__